import JobApi from "api/JobApi";

export const OPEN_MATERIALS_EDIT_MODAL = 'OPEN_MATERIALS_EDIT_MODAL';
export const CLOSE_MATERIALS_EDIT_MODAL = 'CLOSE_MATERIALS_EDIT_MODAL';
export const UPDATE_SALE_MATERIALS_REQUEST = 'UPDATE_SALE_MATERIALS_REQUEST';
export const UPDATE_SALE_MATERIALS_SUCCESS = 'UPDATE_SALE_MATERIALS_SUCCESS';
export const UPDATE_SALE_MATERIALS_FAILURE = 'UPDATE_SALE_MATERIALS_FAILURE';

export const openMaterialsEditModal = (soldDetails) => {
  return {
    type: OPEN_MATERIALS_EDIT_MODAL,
    payload: soldDetails
  }
};

export const closeMaterialsEditModal = () => {
  return {
    type: CLOSE_MATERIALS_EDIT_MODAL
  }
};

const updateSaleMaterialsRequest = () => {
  return {
    type: UPDATE_SALE_MATERIALS_REQUEST
  }
};

const updateSaleMaterialsSuccess = (data) => {
  return {
    type: UPDATE_SALE_MATERIALS_SUCCESS,
    payload: data
  }
};

const updateSaleMaterialsFailure = (error) => {
  return {
    type: UPDATE_SALE_MATERIALS_FAILURE,
    payload: error
  }
};

const jobApi = new JobApi();

export const updateSaleMaterials = (data, callback) => {
  return (dispatch) => {
    dispatch(updateSaleMaterialsRequest());
    return jobApi.updateSaleMaterials(data)
      .done(function(updatedData) {
        dispatch(updateSaleMaterialsSuccess(updatedData));
        if (typeof callback === 'function') callback(updatedData);
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        dispatch(updateSaleMaterialsFailure(textStatus + ': ' + errorThrown));
        console.log(textStatus + ': ' + errorThrown);
      });
  }
};
